import { useLocalStorageKeys } from "@dealer-center/core-interfaces-components";
import { useExperimentPreferences } from "./useExperimentPreferences";
import {
  type DdcExperimentIdType,
  DdcExperimentList
} from "@dealer-center/core-pages-experiment-enablement-interface";

export const useDdcExperimentPreferences =
  useExperimentPreferences<DdcExperimentIdType>(
    DdcExperimentList,
    useLocalStorageKeys.ddcExperimentEnablement
  );
